import { darkTokens, lightTokens, font, radius, makeTokens } from "@livemessage/ui";

/**
 * ADMIN-12 — thème de la console, assis sur les tokens partagés (packages/ui,
 * INV-6). La console est en sombre par défaut ; `lightTokens` reste disponible.
 * Les familles de police des tokens sont des NOMS (RN les charge via expo-font) :
 * côté web on les mappe en piles CSS avec repli système (aucune police externe,
 * CSP stricte — le chargement des fontes propres viendra plus tard).
 */
export { darkTokens, lightTokens, font, radius, makeTokens };

export const theme = darkTokens;

export const fontStack = {
  ui: `"${font.ui}", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`,
  uiSemiBold: `"${font.uiSemiBold}", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif`,
  mono: `"${font.live}", ui-monospace, SFMono-Regular, Menlo, monospace`,
};
